import React from 'react';
import StaticPageTemplate from '../components/ui/StaticPageTemplate';
import styled from 'styled-components';
import { independentLivingPageQuery } from '../queries';

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  color: #2E5984;
  margin-bottom: 1rem;
`;

const Paragraph = styled.p`
  margin-bottom: 1rem;
  line-height: 1.6;
  white-space: pre-line;
`;

const IndependentLiving = () => {
  const defaultData = {
    title: "Independent Living",
    subtitle: "Affordable and comfortable accommodation",
    iluHeader: "Independent Living Units (ILU)",
    iluText: "Tandara provides affordable and comfortable accommodation in 48 independent living units at Sheffield and Railton. All units are located within short distance to shopping facilities, local parish churches and other community amenities.",
    applicationHeader: "How do I apply or get more information?",
    applicationText: "Enquiries should be directed to the Tandara office during office hours (9:00 am – 5:00 pm Monday to Friday) on 03 6491 1277 or see the Contact Us page."
  };

  const customContent = (pageData) => (
    <>
      <Section>
        <SectionTitle>
          {pageData.iluHeader}
        </SectionTitle>
        <Paragraph>
          {pageData.iluText}
        </Paragraph>
      </Section>
      
      <Section>
        <SectionTitle>
          {pageData.applicationHeader}
        </SectionTitle>
        <Paragraph>
          {pageData.applicationText}
        </Paragraph>
      </Section>
    </>
  );

  return (
    <StaticPageTemplate
      pageName="independentLivingPage"
      query={independentLivingPageQuery}
      defaultData={defaultData}
      customContent={customContent}
    />
  );
};

export default IndependentLiving;
